<template>
  <div class="form-group"
       :class="filterClass">
    <vue-at :members="variables"
                at="$" name-key="key">
      <template slot="item" slot-scope="s">
        <span class="item-key">${{ s.item.key }}</span>
        <span v-text="s.item.name"></span>
      </template>
      <textarea class="form-control editor"
                :rows="rows"
                :disabled="disabled"
                ref="filter"
                :style="editorStyle"
                v-model.trim="currentFilter"
                placeholder="Filtres...">
      </textarea>
      <span class="glyphicon editor-feedback form-control-feedback"
            :class="feedbackClass"
            aria-hidden="true"></span>
    </vue-at>
    <small class="result-count" v-html="lineCount" v-if="showCount"></small>
  </div>
</template>

<script>
import debounce from 'debounce'
import vueAt from 'vue-at/dist/vue-at-textarea'

import filter from '@/sui/tools/filter'
import ice from '@/sui/tools/ice'

export default {
  name: 'sui-filter-input',
  props: {
    variables: {
      type: Array,
      default: () => []
    },

    list: {
      type: Array,
      required: true
    },

    value: {
      type: Object,
      required: true
    },

    showCount: {
      type: Boolean,
      default: true
    },

    rows: {
      type: Number,
      default: 1
    },

    resize: {
      type: String,
      default: 'none'
    },

    whiteSpace: {
      type: String,
      default: 'nowrap'
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function () {
    return {
      currentFilter: this.value.filter,
      appliedFilter: this.value.filter,
      data: ice.freeze(this.list)
    }
  },

  watch: {
    list: function (val) {
      this.data = ice.freeze(val)
    },

    'value.filter': function (f) {
      this.currentFilter = f
    },

    currentFilter: function (val) {
      this.index = 1
      this.triggerFilter()
    },

    filteredList: function (val) {
      this.$emit(
        'input',
        {
          filter: this.currentFilter,
          list: ice.freeze(val),
          status: this.filterStatus,
          error: this.filterTest.error
        }
      )
    }
  },

  mounted: function () {
    this.$emit(
      'input', { filter: this.currentFilter, list: this.filteredList }
    )
  },

  computed: {
    filterStatus: function () {
      if (this.appliedFilter === '' ||
          this.currentFilter !== this.appliedFilter) {
        return 0
      }

      if (this.filterTest.error != null) {
        return 2
      }
      return 1
    },

    filterDictionary: function () {
      return filter.listToDictionnary(this.variables)
    },

    filterTest: function () {
      if (this.appliedFilter == null || this.appliedFilter === '') {
        return { error: '' }
      }
      const dic = this.filterDictionary
      return filter.build(dic, this.appliedFilter)
    },

    filteredList: function () {
      const list = this.list
      if (this.filterTest.error != null) {
        return list
      }

      const expr = this.filterTest
      const reducer = (result, s) => {
        if (expr(s)) {
          result.push(s)
        }
        return result
      }
      const t = list.reduce(reducer, [])
      return t
    },

    filterClass: function () {
      return {
        'has-error': this.filterStatus === 2,
        'has-success': this.filterStatus === 1
      }
    },

    feedbackClass: function () {
      if (this.filterStatus === 2) {
        return 'glyphicon-remove'
      }

      if (this.filterStatus === 1) {
        return 'glyphicon-ok'
      }

      return null
    },

    triggerFilter: function () {
      return debounce(this.triggerFilterImpl, 800)
    },

    lineCount: function () {
      if (this.data == null) {
        return 'chargement...'
      }

      if (this.filterStatus === 2) {
        return `Filtre invalide : ${this.filterTest.error}.`
      }

      const count = this.filteredList.length
      switch (count) {
        case 0:
          return 'Aucun résultat'
        case 1:
          return '1 résultat'
      }

      return `${count} résultats`
    },

    editorStyle: function () {
      return {
        'white-space': this.whiteSpace,
        'resize': this.resize
      }
    }
  },

  methods: {
    triggerFilterImpl: function () {
      this.appliedFilter = this.currentFilter
    }
  },
  components: {
    vueAt
  }
}
</script>

<style scoped lang="less">
@import '~variables';
.result-count {
    color: gray;
}

.editor-feedback {
  padding: 0.3rem;
}

.editor {
  padding: 0.7rem;
  padding-bottom: 0rem;
  overflow-x: auto;
  width: 100%;
  resize: none;
}

.item-key {
  padding-left: 1rem;
  padding-right: 2rem;
  min-width: 30rem;
}
</style>

<style>
.atwho-view {
  max-width: none !important;
  bottom: auto !important;
  top: 3rem;
}
</style>
